export default [
  ({ state, resolve, props }) => {
    const value = state.get(`selectr.${props.namespace}.input.value`)
    if (value === '') {
      let focusedTag = state.get(`selectr.${props.namespace}.focusedTag`)
      const tags = state.get(`selectr.${props.namespace}.selected`)
      if (tags.length > 0) {
        if (focusedTag !== null) {
          // unset current focus
          state.set(
            `selectr.${props.namespace}.selected.${focusedTag}.focused`,
            false
          )
          if (focusedTag + 1 <= tags.length - 1) {
            state.set(`selectr.${props.namespace}.focusedTag`, focusedTag + 1)
            state.set(
              `selectr.${props.namespace}.selected.${focusedTag + 1}.focused`,
              true
            )
          } else {
            state.set(`selectr.${props.namespace}.focusedTag`, null)
            state.set(`selectr.${props.namespace}.focusInput`, true)
          }
        }
      }
      state.set(`selectr.${props.namespace}.performTagUnfocus`, true)
    }
  }
]
